// client/src/context/UserContext.jsx
// Provides user auth state to all components without prop drilling
import React, { createContext, useContext } from 'react';

const UserContext = createContext(null);

export function UserProvider({ user, onLogout, children }) {
  return (
    <UserContext.Provider value={{ user, onLogout }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error('useUser must be used within a UserProvider');
  return ctx;
}

export default UserContext;
